import { Directive, HostListener } from '@angular/core';

@Directive({
  selector: '[ewPreventScroll]',
  standalone: true,
})
export class PreventScrollDirective {
  // Prevents scrolling on the input when the user tries to scroll with the mouse wheel.
  @HostListener('wheel', ['$event'])
  onWheel(event: WheelEvent): void {
    event.preventDefault();
  }

  // Prevents user to change input value using arrow up or arrow down.
  @HostListener('keydown', ['$event'])
  onKeyDown(event: KeyboardEvent): void {
    if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
      event.preventDefault();
    }
  }
}
